/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * Fields a primary member may change on one of their own family members from the public site.
 * Email changes go through the same staged confirm-by-link flow as regular members.
 * @export
 * @interface WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
 */
export interface WebApiPublicSiteDtoUpdateOwnFamilyMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiPublicSiteDtoUpdateOwnFamilyMemberDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoUpdateOwnFamilyMemberDto interface.
 */
export function instanceOfWebApiPublicSiteDtoUpdateOwnFamilyMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoFromJSON(json: any): WebApiPublicSiteDtoUpdateOwnFamilyMemberDto {
    return WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoUpdateOwnFamilyMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
    };
}

export function WebApiPublicSiteDtoUpdateOwnFamilyMemberDtoToJSON(value?: WebApiPublicSiteDtoUpdateOwnFamilyMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
    };
}

